import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {getVisualizationConfigGQLFromChartStep} from 'analysis-tool/data/StepConfigUtils';
import {assert} from 'Asserts';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {VISUALIZATION_TYPE_TO_PARAMETERS_TYPENAME} from 'insights/analytics-visualizations/AnalyticsVisualizationConstants';
import {
  VisualizationConfig,
  VisualizationType,
} from 'insights/universal-blocks/SharedUniversalBlockViewTypes';
import {getPipelineStepConfig} from 'pipelines/StepShapeUtils';

export default function getStepVisualizationConfigAndName(chartOrTableStep: GetAnalysisPipelineStep): {
  visualizationConfig: VisualizationConfig;
  viewName: string;
} {
  assert(
    [PipelineStepType.CHART_VIEW, PipelineStepType.TABLE_VIEW].includes(chartOrTableStep.definition.stepType),
    'Unexpected step type'
  );

  if (chartOrTableStep.definition.stepType === PipelineStepType.CHART_VIEW) {
    const config = getVisualizationConfigGQLFromChartStep(chartOrTableStep);

    return {
      viewName: config.visualizationName,
      visualizationConfig: config.visualizationConfig,
    };
  } else {
    return {
      viewName: getPipelineStepConfig(chartOrTableStep, PipelineStepType.TABLE_VIEW, 0).viewName,
      visualizationConfig: {
        __typename: 'AnalyticsVisualizationNode',
        id: `stub-id-${chartOrTableStep.id}`,
        parameters: {
          __typename: VISUALIZATION_TYPE_TO_PARAMETERS_TYPENAME[VisualizationType.TABLE],
          displayColumnsJson: null,
        } as VisualizationConfig['parameters'],
      },
    };
  }
}
